import React from 'react';
import { useAppDispatch, useAppSelector } from '../../Redux/hooks';
import { allcontentOrConfigData } from '../../Redux/Reducers/GlobalSlice';
import { CONTENT_OR_CONFIG_TABLE_MAPPING, FALLBACK_URLS } from '../../utils/constants';
import { getKeyValuePair } from '../../utils/ContentOrConfigUtil';
import "./Footer.scss";
import { adSign } from '../../utils/validation';
import { roles } from 'aria-query';
export interface IFooterProps { };

const Footer: React.FunctionComponent<IFooterProps> = () => {
  const dispatch: any = useAppDispatch();
  const contentOrConfigData: any = useAppSelector(allcontentOrConfigData);
  const tableName: string = CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.tableName;
  const FOOTER: string = CONTENT_OR_CONFIG_TABLE_MAPPING?.Global?.FOOTER_CONTENT_TYPE;
  let _role = useAppSelector((state: any) => state?.global?.role) || "";

  return <div className="Footer" data-testid="footer">
    {getKeyValuePair(contentOrConfigData, tableName, FOOTER) ?
      <div dangerouslySetInnerHTML={{ __html: getKeyValuePair(contentOrConfigData, tableName, adSign(_role)) }} />
      :
      <div>
        <p>
          Use of this app constitutes acceptance of the <a 
            href={FALLBACK_URLS.FREIGHTPOWER_TERMS_OF_USE} target="_blank" rel="noopener noreferrer">TERMS OF USE
          </a> and the Schneider FreightPower® <a href={FALLBACK_URLS.PRIVACY_POLICY} target="_blank" rel="noopener noreferrer">PRIVACY POLICY</a>
        </p>
        <p>Need Help? Email <a href={FALLBACK_URLS.EMAIL} target="_blank" rel="noopener noreferrer">FreightPowerCarrier@schneider.com</a>
          <br />for assistance.</p>
      </div>
    }
  </div>
}
export default Footer;